import { v4 as uuidv4 } from 'uuid';
import { RecordType } from '@xbcb/shared-types';
import { UsDrawbackClaim } from '../../../loadableComponents';
import { executeMutation } from 'libs/executeMutation';
import { WorkOrderRoute } from '..';
import {
  queryUsDrawbackClaim,
  updateUsDrawbackClaim,
  createUsDrawbackClaimCbpMutation,
} from './usDrawbackClaim.query';

const usDrawbackClaimRoute: WorkOrderRoute = {
  Page: UsDrawbackClaim,
  recordType: RecordType.US_DRAWBACK_CLAIM,
  queries: { get: queryUsDrawbackClaim, update: updateUsDrawbackClaim },
  getTitleField: () => 'brokerNumber',
  hideDefaultEditButton: () => true,
  submitButtons: [
    {
      key: 'submitClaim',
      text: 'Submit claim',
      show: ({ existingRecord }) => Boolean(existingRecord?.id),
      onSubmit: async ({ updatedRecord }) => {
        await executeMutation({
          mutation: createUsDrawbackClaimCbpMutation,
          variables: {
            idempotencyKey: uuidv4(),
            usDrawbackClaimId: updatedRecord.id,
          },
          successMessage: 'Claim submitted to CBP',
        });
      },
    },
  ],
};

export default usDrawbackClaimRoute;
